__turbopack_context__.v({
  "CategoriesMenuScroll": "KuP5Ja_CategoriesMenuScroll",
  "disableButton": "KuP5Ja_disableButton",
  "enableButton": "KuP5Ja_enableButton",
});
